import { useEffect } from 'preact/hooks';
import { tv } from 'tailwind-variants';
import { skillName } from '../../state/i18n';
import { pruneExpiredXpDrops, xpDrops } from '../../state/xpDrops';

const xpDropStyles = tv({
  slots: {
    root: [
      'fixed top-24 left-1/2 -translate-x-1/2 z-[930]',
      'pointer-events-none',
      'flex flex-col items-center gap-1',
      'w-72',
    ],
    drop: [
      'px-2.5 py-1 rounded-md',
      'border',
      'bg-slate-950/80 border-slate-600/60',
      'shadow-[0_2px_10px_rgba(0,0,0,0.45)]',
      '[animation:xp-drop-rise_1.6s_ease-out_forwards]',
      'origin-bottom-right',
      'flex items-center gap-1.5',
    ],
    dropLeveled: ['border-rs-gold/80 bg-amber-950/75'],
    xp: ['text-xs font-semibold text-emerald-300 tabular-nums'],
    skill: ['text-[10px] uppercase tracking-wide text-rs-parchment-dark'],
  },
});

export const XpDrops = () => {
  const styles = xpDropStyles();
  const drops = xpDrops.value;

  useEffect(() => {
    const interval = setInterval(pruneExpiredXpDrops, 120);
    return () => {
      clearInterval(interval);
    };
  }, []);

  if (drops.length === 0) {
    return null;
  }

  return (
    <div class={styles.root()}>
      {drops.map((drop) => (
        <div
          key={drop.id}
          class={`${styles.drop()} ${drop.leveledUp ? styles.dropLeveled() : ''}`}
          style={{ animationDelay: `${(drop.id % 4) * 0.03}s` }}
        >
          <span class={styles.xp()}>
            +{drop.xpGained} {skillName({ skillId: drop.skillId }).toLowerCase()} xp
          </span>
        </div>
      ))}
    </div>
  );
};
